/**
 * Created by Stefann on 01/04/2019.
 */
import Condition from "@/lib/Condition";

export class Guarantee {
    public branch?: any;
    constructor(public id: number, public label: string, public slug: string, public description: string, public conditions: Array<Condition>, public conditionsAreOptional: boolean) {
        this.conditions.forEach((condition: Condition) => condition.init());
    }

    public canDisplay() {
        return true;
        const isFulfilled = (condition: Condition) => {
            condition.check();
            return condition.isFulfilled;
        };
        if(!this.conditions.length){
            return true;
        }
        return this.conditionsAreOptional ? this.conditions.some(isFulfilled) : this.conditions.every(isFulfilled);
    }
}
